module.exports = __webpack_public_path__ + "static/media/title_7.9e98d8ac.svg";